export const genderTypes = [
    { option: "female", label: "Female - She/her" },
    { option: "male", label: "Male - He/him" },
    { option: "nonBinary", label: "Non binary - They/them" },
]